import MyProfileContainer from './myProfileContainer';
export default MyProfileContainer;